import PartMessage from './PartMessage'
import { Delete, Error, Info, NotInterested, Store } from '@mui/icons-material'

import { show, show as showNiceModal } from '@ebay/nice-modal-react'
import Check from '@mui/icons-material/Check'
import {
  getCartMode,
  isThereOnlyTheMiscellaneousCart,
  removeProductThunk,
} from 'cart'
import {
  ABSOLUTE_MAX_QUANTITY,
  I18n,
  MY_PLACE_SELLER,
  useBrandImage,
  useWindowSize,
} from 'common'
import {
  IdValueGeneric,
  InventoryDisplay,
  NonCachedSearchType,
  ProductModel,
} from 'interfaces'
import { observer } from 'mobx-react-lite'
import { ReactElement, useCallback, useEffect, useRef, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import WarningLabel from 'src/features/WarningLabel'
import SelectCartDrawer from '../SelectCartDrawer'
import { storeInfo } from 'src/helpers/StoreInfo'
import { useSellerStore } from 'src/store/search/SellerStore'
import { store } from 'store'
import styled from 'styled-components'
import { EmbeddedCommunicationsManager } from '../../../../../../src/api/embedded/EmbeddedCommunicationsManager'
import LaborLookupDrawer from '../../../../../../src/features/labor/lookup/LookupDrawer'
import { QuantityPriceBreak } from '../quantityPriceBreak'
import miscellaneousVehicle from '../../../../../../src/features/search/Results/utils/miscellaneousVehicle'
import { VehicleFitmentDrawer } from '../../../../../../src/features/vehicleFitment/components/VehicleFitmentDrawer'
import { getInterchangeParts } from '../../../../../../src/helpers/getInterchangeParts'
import { LocationType } from '../../../../../../src/helpers/locationType'
import { StoreInstances } from '../../../../../../src/store/StoreInstancesContainer'
import { CartMode } from '../../../../../../src/store/models/ShoppingCartModels'
import { Vehicle } from '../../../../../../src/store/models/Vehicles'
import { CatalogNodeType } from '../../../../../../src/store/partsCatalog/interfaces'
import { useBannerPromotionStore } from '../../../../../../src/store/promotion/BannerPromotionStore'
import { useSearchStore } from '../../../../../../src/store/search/SearchStore'
import { useUiStateStore } from '../../../../../../src/store/uiState/UiStateStore'
import { useUserStore } from '../../../../../../src/store/user/UserStore'
import { UserAttributeKey } from '../../../../../../src/store/user/interfaces'
import { breakpoints } from '../../../../../../src/theme/breakpoints'
import { defaultTheme } from '../../../../../../src/theme/index'
import { Button } from '../../../../../../src/ui-components/forms/Button'
import { Price } from '../../../../../../src/ui-components/products/Price'
import {
  AlternateTag,
  ReplacementTag,
} from '../../../../../../src/ui-components/products/ProductTags'
import { QuantitySelector } from '../../../../../../src/ui-components/products/QuantitySelector'
import { Thumbnail } from '../../../../../../src/ui-components/products/Thumbnail'
import { useQuantitySelectorToolbox } from '../../../../../../src/ui-components/products/useQuantitySelectorToolbox'
import carIcon from '../../../assets/images/might-not-match-vehicle.svg'
import { useProductInfo } from '../../../hooks/useProductInfo'
import { useResultsStore } from '../../../store/ResultsStore'
import { BundleTooltip } from '../BundleTooltip'
import { ProdcutPriceDetialsDrawer } from '../MobileProductPriceDetailsDrawer'
import { MultiSellerInterchangeTooltip } from '../MultiSellerInterchangeTooltip'

interface ProductCardProps {
  product: ProductModel
  alternateFor?: ProductModel
  replacementFor?: ProductModel
  green?: boolean
  index?: number
}

export const ProductCardMobile = observer(
  ({
    alternateFor = undefined,
    replacementFor = undefined,
    product,
    green,
  }: ProductCardProps): ReactElement => {
    const navigate = useNavigate()
    const uiStore = useUiStateStore()
    const { getSelectedSeller } = useSellerStore()
    const {
      setShowBrandLinksDrawer,
      setShowLaborResultSearchResultsModal,
      isCondensedView,
      isMultiLocationEnabled,
      showBundles,
    } = uiStore
    const resultsStore = useResultsStore()
    const {
      lastNonCachedSearch,
      setMultiPartInquiryResults,
      showAddAlltoCart,

      sellerDetails,
    } = resultsStore
    const searchStore = useSearchStore()

    const selectedCurrentVehicle = searchStore.currentVehicle?.engine
      ? searchStore.currentVehicle
      : miscellaneousVehicle

    const { cartProduct } = useProductInfo({
      product,
    })

    const {
      updateQuantity,
      inCart,
      currentQty,
      showLocationSelector,
      handleAddVehiclePartToCart,
      priceSpinner,
      inCartText,
      yourCostAfterPriceBreaks,
      isZeroCost,
      setCurrentQty,
      activeLocation,
      setPriceSpinner,
      inStockSomewhere,
      orderIfNotAvailable,
      invDisplayState,
    } = cartProduct

    const [addToCartInProgress, setAddToCartInProgress] = useState(false)

    const { handleCoverageMatch } = useBannerPromotionStore()

    const {
      partImages,
      description,
      extendedDescription,
      lineCode,
      partNumber,
      orderNumber,
      isStocked,
      isExatcMatch,
    } = product

    const userStore = useUserStore()

    const hideRoutingDiagramContent = description === 'Routing Diagram'
    const [openPriceInformation, setOpenPriceInformation] =
      useState<boolean>(false)
    const [showTooltip, setShowTooltip] = useState<boolean>(false)
    const { userId } = StoreInstances.userStore.preferences

    const {
      warrantyDescription,
      list,
      coreCost,
      qtyAvailable,
      locType,
      called,
      otherPrices = [],
    } = activeLocation || {}

    const contactNumber: string =
      storeInfo.getContactAdressInfo()?.phone?.phoneNumber || ''

    const { width: windowSize } = useWindowSize()

    const vehicleFitment = sellerDetails
      ? sellerDetails.coverageKey === '' &&
        userStore?.preferences?.epeFeatures_buyersGuide === 'true'
      : userStore?.preferences?.epeFeatures_buyersGuide === 'true'

    const thumbnail = partImages?.length
      ? partImages.find((img) => img.type === 'thumbnail')?.url
      : ''
    const largerThumbnail = partImages?.length
      ? partImages.find((img) => img.type === 'large')?.url
      : null
    const productImage = largerThumbnail ?? thumbnail

    const [brandImgUrl] = useBrandImage(product)

    const priceBreaks = activeLocation?.priceBreaks
    const extenDescSupposeLength = isCondensedView ? 15 : 65
    const [showFullDesc, setShowFullDesc] = useState(
      !extendedDescription ||
        extendedDescription.length < extenDescSupposeLength
    )

    const showNonASTLinks =
      !EmbeddedCommunicationsManager.isAstPunchOut &&
      resultsStore.lastNonCachedSearch !==
        NonCachedSearchType.searchByAstNavigation

    const shouldShowLaborLink =
      lastNonCachedSearch !== NonCachedSearchType.searchByInterchange &&
      lastNonCachedSearch !== NonCachedSearchType.searchByText &&
      lastNonCachedSearch !== NonCachedSearchType.searchByMultiPartsInquiry &&
      searchStore.currentVehicle?.type?.id === 111 &&
      userStore.getUserAttribute(UserAttributeKey.epeFeatures_labor) === 'true'

    const isApplicationPart = (): boolean => {
      return !searchStore?.showPartsNotFitVehicle
    }

    const showDrawer = (): void => {
      if (!inCart) {
        show(SelectCartDrawer, {
          product,
          handleAddVehiclePartToCart,
          activeLocation,
          ...(isMultiLocationEnabled() && { showLocationSelector }),
          seller: getSelectedSeller(),
          currentVehicle: searchStore.currentVehicle,
        })
      }
    }

    const handleAddToCart = async (): Promise<void> => {
      if (inCart) return

      await shouldShowLocationSelector()

      handleCoverageMatch(orderNumber)

      const isSingleCartMode = getCartMode() === CartMode.SINGLE_VEHICLE

      const isInterchangeSearch =
        resultsStore.lastNonCachedSearch ===
        NonCachedSearchType.searchByInterchange

      const isOnlyTheMiscellaneousCart = isThereOnlyTheMiscellaneousCart()

      const targetVehicle = searchStore.currentVehicle?.engine?.id
        ? searchStore.currentVehicle
        : miscellaneousVehicle

      if (isSingleCartMode) {
        await addPartToCart(targetVehicle)
      } else {
        if (isInterchangeSearch) {
          // https://praxent.atlassian.net/browse/BABW-85?focusedCommentId=65782
          if (
            isOnlyTheMiscellaneousCart &&
            !searchStore.currentVehicle?.engine?.id
          ) {
            await addPartToCart(miscellaneousVehicle)
          } else {
            showDrawer()
          }
        } else if (isEligibleApplicationPart()) {
          await addPartToCart(searchStore.currentVehicle)
        } else if (!isOnlyTheMiscellaneousCart) {
          showDrawer()
        } else {
          await addPartToCart(targetVehicle)
        }
      }
    }

    const addPartToCart = async (vehicle: Vehicle): Promise<void> => {
      setAddToCartInProgress(true)
      await handleAddVehiclePartToCart(vehicle)
      setAddToCartInProgress(false)
    }

    const isEligibleApplicationPart = (): boolean => {
      return (
        isApplicationPart() && Boolean(searchStore.currentVehicle?.engine?.id)
      )
    }

    const handleClickVehicleFitment = () => {
      showNiceModal(VehicleFitmentDrawer, {
        product,
      })
    }

    const handleLaborLookup = () => {
      showNiceModal(LaborLookupDrawer, {
        vehicle: searchStore.currentVehicle,
        product,
        setLaborResult: setShowLaborResultSearchResultsModal,
      })
    }

    const findGroupValue = (id: string): string => {
      return StoreInstances.partsCatalog.findNode(id, CatalogNodeType.GROUP)
        ?.value
    }

    const getCategoryId = (id: string): string => {
      let categoryId = null
      StoreInstances.partsCatalog.categoryGroups().forEach((category) => {
        category.getChildren().forEach((group) => {
          if (parseInt(group.id, 10) === parseInt(id, 10)) {
            categoryId = category.id
          }
        })
      })
      return (categoryId || '').toString()
    }

    // shouldn't call when qty is less than intialSelectorQty
    const updatePriceBreaks = async (qty: number) => {
      if (qty < activeLocation.displayMinQty) {
        uiStore.displayErrorNotification(
          `Minimum quantity should be ${activeLocation.displayMinQty}`
        )
        return
      }
      await updateQuantity(qty, activeLocation)
      setPriceSpinner(true)
      setCurrentQty(qty)
    }

    const handleClickQuantityPriceBreak = () => {
      showNiceModal(QuantityPriceBreak, {
        updatePriceBreaks,
        priceBreaks,
        image: thumbnail,
        partNumber,
        description,
        lineCode,
      })
    }

    const parseAllEngines = (
      item: IdValueGeneric<string, string>,
      categoryId: string
    ) => {
      const allEnginesSelected =
        searchStore.currentVehicle?.engine?.value === 'All Engine'
      searchStore.setGfxItem({
        id: item.id,
        value: item.value,
      })
      searchStore.setGroupId(categoryId)
      if (allEnginesSelected) {
        uiStore.setShowEnginesModal(true)
        searchStore.getEngineOptions()
      } else {
        searchStore.openGFX()
      }
    }

    const navigateToProductDetails = () => {
      const multiSellerParams = getSelectedSeller()?.coverageKey
        ? `&coverageKey=${getSelectedSeller().coverageKey}`
        : ''
      resultsStore.setSearchResultPageScrollPosition(window.scrollY)
      const productPath = `/product/?partNumber=${product.partNumber}&lineCode=${product.lineCode}${multiSellerParams}`
      const productState = JSON.parse(JSON.stringify(product))
      navigate(productPath, { state: productState })
    }

    const setPriceDetialsDrawer = (show: boolean) => {
      setOpenPriceInformation(show)
    }

    useEffect(() => {
      if (showAddAlltoCart)
        setMultiPartInquiryResults(product, activeLocation, currentQty)
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
      if (showAddAlltoCart && resultsStore) {
        resultsStore.updateMultiPartInquiryResults(
          product,
          activeLocation,
          currentQty
        )
      }
    }, [activeLocation, currentQty, product, resultsStore, showAddAlltoCart])

    const isExactMatch = isExatcMatch

    useEffect(() => {
      if (!resultsStore) {
        return
      }
      resultsStore.setUpdatedPartInfoDetails({
        product,
        updatedQty: currentQty,
        updatedLocation: activeLocation,
      })
      searchStore.setUpdatedPartInfoDetails({
        product,
        updatedQty: currentQty,
        updatedLocation: activeLocation,
      })
    }, [activeLocation, currentQty, product, resultsStore, searchStore])

    function handleTooltipDisplay() {
      if (!sellerDetails || !sellerDetails.coverageKey) {
        return false
      }
      const key = `${userId}_multiseller_tooltip_display`
      const storedValue = localStorage.getItem(key)

      if (storedValue === null) {
        localStorage.setItem(key, 'true')
        return true
      }

      return storedValue === 'true'
    }

    const handleDeletePart = () => {
      const seller = getSelectedSeller() ?? MY_PLACE_SELLER

      store.dispatch(
        removeProductThunk({
          product,
          quantity: ABSOLUTE_MAX_QUANTITY,
          locationId: activeLocation.locationId.toString(),
          vehicle: selectedCurrentVehicle,
          seller,
          removeFromAllLocations: true,
        })
      )
    }

    const { onInputTooltipMsg, shouldShowLocationSelector } =
      useQuantitySelectorToolbox(cartProduct)

    const updateQuantityRef = useRef(updateQuantity)
    updateQuantityRef.current = updateQuantity

    const activeLocationRef = useRef(activeLocation)
    activeLocationRef.current = activeLocation

    const handleQtyChange = useCallback(
      (newQty: number): Promise<void> => {
        setPriceSpinner?.(true)
        return updateQuantityRef
          .current(newQty, activeLocationRef.current)
          .then(() => {
            // To satisfy TS void.
          })
      },
      [setPriceSpinner]
    )

    const isPrimary = activeLocation?.locType === 'primary'

    return (
      <MobileViewCard>
        <MobileViewRow green={green}>
          <MobileBrandLink className="align-items-center justify-content-center">
            <Thumbnail
              urlOrBase64={productImage}
              width={100}
              height={100}
              placeholder
            />

            {brandImgUrl && (
              <BrandWrapper
                onClick={() => {
                  setShowBrandLinksDrawer(true, product)
                }}
              >
                <Thumbnail
                  urlOrBase64={brandImgUrl}
                  width={100}
                  height={100}
                  alt="brand"
                />
              </BrandWrapper>
            )}
            <BrandWrapperNoInfo>
              {!brandImgUrl && product.brandName && product.brandName}
              {!brandImgUrl && !product.brandName && product.manufacturerName}
            </BrandWrapperNoInfo>
          </MobileBrandLink>
          <MobileViewProductInformation>
            <MobileProductDetails>
              {alternateFor || replacementFor ? (
                <ProductName isLink={false}>{description}</ProductName>
              ) : (
                <ProductName isLink onClick={navigateToProductDetails}>
                  {description}
                </ProductName>
              )}
              {searchStore.showPartsNotFitVehicleLabel &&
                searchStore?.currentVehicle.engine?.value && (
                  <CardIconContainer>
                    <CardIcon src={carIcon} alt="Car Icon" />
                    <MessageCardIcon>
                      <I18n name="mayNotFitYour" />
                    </MessageCardIcon>
                  </CardIconContainer>
                )}
              {replacementFor && (
                <ReplacementTag>{replacementFor.partNumber}</ReplacementTag>
              )}
              {showFullDesc && extendedDescription && (
                <Description>
                  {extendedDescription} &nbsp;
                  {extendedDescription.length > 150 && (
                    <ReadMore onClick={() => setShowFullDesc(false)}>
                      [<I18n name="readLess" />]
                    </ReadMore>
                  )}
                </Description>
              )}
              {!showFullDesc && (
                <Description onClick={() => setShowFullDesc(true)}>
                  {extendedDescription.substring(0, 150)}...&nbsp;
                  <ReadMore>
                    [<I18n name="readMore" />]
                  </ReadMore>
                </Description>
              )}
              {product?.unAnsweredSpecificConditions?.length > 0 && (
                <FitsConditions>
                  <Info className="fitmentInfoIcon" />{' '}
                  {product?.unAnsweredSpecificConditions?.map((item, idx) => (
                    <>
                      {item}&nbsp;
                      {idx <
                        product.unAnsweredSpecificConditions.length - 1 && (
                        <>|&nbsp;</>
                      )}
                    </>
                  ))}
                </FitsConditions>
              )}
            </MobileProductDetails>
            {isExactMatch && (
              <ExactMatchContainer>
                <IconCheck></IconCheck>
                <ExactMatchLabel>
                  <I18n name="exactMatch" />
                </ExactMatchLabel>
              </ExactMatchContainer>
            )}
            <MobilePriceInformation>
              <NoWrap>
                <span style={{ whiteSpace: 'nowrap' }}>
                  <I18n name="partNum" />
                  :&nbsp;
                </span>
                <b>{partNumber}</b>
              </NoWrap>
              <NoWrap>
                <I18n name="lineCode" />: <b>{lineCode}</b>
              </NoWrap>
            </MobilePriceInformation>
            <PriceInformation>
              {isZeroCost ? (
                <Wrap className="fw-bold">
                  <I18n name="callForPrice" />
                </Wrap>
              ) : (
                <PriceWrapper>
                  <PriceSubCell>
                    {/* Replacing list price with yourcost as per ticket MPV3-4022,
                        TODO - Display all price details later with updated figma designs for mobile view */}

                    {/* <BigPrice>
                          <Price num={list} />
                        </BigPrice>
                        {coreList > 0 && <Price num={coreList} />} */}

                    {priceSpinner ? (
                      <Spinner
                        style={{
                          height: '20px',
                          width: '20px',
                          color: defaultTheme.colors.warningBackground,
                        }}
                      />
                    ) : (
                      <BigPrice>
                        <Price num={yourCostAfterPriceBreaks()} />
                      </BigPrice>
                    )}
                    {coreCost > 0 && <Price num={coreCost} />}

                    {
                      <span
                        style={{
                          color: `${defaultTheme.colors.blueLight}`,
                          marginLeft: '8px',
                        }}
                      >
                        <LocalLink onClick={() => setPriceDetialsDrawer(true)}>
                          {'Details'}
                        </LocalLink>
                        {priceBreaks?.length > 0 && (
                          <LocalLinkPriceBreak
                            onClick={handleClickQuantityPriceBreak}
                          >
                            <NoWrap>
                              <I18n name="qtyPriceBreak" />
                            </NoWrap>
                          </LocalLinkPriceBreak>
                        )}
                      </span>
                    }
                  </PriceSubCell>
                </PriceWrapper>
              )}
            </PriceInformation>
            {alternateFor && (
              <AlternateTag>{alternateFor.partNumber}</AlternateTag>
            )}
            {showBundles() &&
              product?.eligibleBundles &&
              product?.eligibleBundles?.length > 0 && (
                <BundleTooltip bundles={product?.eligibleBundles} />
              )}
            <MobileWarrentyDescription>
              {warrantyDescription && (
                <div className="mt-3" style={{ maxWidth: 250 }}>
                  <b>
                    <I18n name="warrantyInfo" />
                    :&nbsp;
                  </b>
                  {warrantyDescription}
                </div>
              )}
            </MobileWarrentyDescription>
            <MobileLocationAvalibailty>
              {invDisplayState === InventoryDisplay.AVAILABLE_AT_LOCATION && (
                <Wrap className="fw-bold">
                  {qtyAvailable}&nbsp;
                  <I18n name="at" />
                  &nbsp;
                  {locType === 'primary' && (
                    <Store
                      htmlColor={defaultTheme.colors.green}
                      sx={{
                        width: isCondensedView ? '20px' : '24px',
                        height: isCondensedView ? '20px' : '24px',
                      }}
                    />
                  )}
                  {called}
                </Wrap>
              )}
              {invDisplayState === InventoryDisplay.SHOW_ZERO && (
                <Wrap className="fw-bold">
                  {!inStockSomewhere && isZeroCost ? (
                    <>
                      <NotInterested
                        htmlColor={defaultTheme.colors.red}
                        sx={{
                          width: isCondensedView ? '20px' : '24px',
                          height: isCondensedView ? '20px' : '24px',
                        }}
                      />
                      <I18n
                        name="callForAvailability"
                        style={{ fontSize: isCondensedView && '14px' }}
                      />
                    </>
                  ) : (
                    <I18n
                      name="zeroAvailableAtLocation"
                      textReplacement={[called]}
                    />
                  )}
                </Wrap>
              )}
              {invDisplayState === InventoryDisplay.CALL_FOR_AVAILABILITY && (
                <>
                  <Wrap className="fw-bold">
                    <Error
                      htmlColor={defaultTheme.colors.primary}
                      sx={{
                        width: isCondensedView ? '20px' : '24px',
                        height: isCondensedView ? '20px' : '24px',
                      }}
                    />
                    &nbsp;
                    <I18n
                      name="callForAvailability"
                      style={{ fontSize: isCondensedView && '14px' }}
                    />
                  </Wrap>
                  <Description>
                    <I18n
                      name="itemUnavailableAtAllLocations"
                      style={{ fontSize: isCondensedView && '14px' }}
                    />
                    <br />
                    {contactNumber && (
                      <I18n
                        name="pleaseContactForInformation"
                        textReplacement={[contactNumber]}
                        style={{ fontSize: isCondensedView && '14px' }}
                      />
                    )}
                  </Description>
                </>
              )}
              {activeLocation?.locType === LocationType.ORDER_FROM_PRIMARY && (
                <WarningLabel
                  name="orderFromPrimaryWarining"
                  style={{
                    width: '150px',
                  }}
                />
              )}
              {inStockSomewhere && (
                <Wrap>
                  <LocalLink
                    onClick={showLocationSelector}
                    style={{ marginTop: isCondensedView && '4px' }}
                  >
                    <I18n name="moreLocations" />
                  </LocalLink>
                </Wrap>
              )}
            </MobileLocationAvalibailty>
            <MobileCartOPerations>
              <MinQtyDiplayer>
                <span>{`Per Car Qty: ${
                  activeLocation?.minQty ? activeLocation.minQty : '1'
                }`}</span>
              </MinQtyDiplayer>
              <QuantitySelector
                orderIfNotAvailable={orderIfNotAvailable && isPrimary}
                onChange={handleQtyChange}
                onRemove={() => undefined}
                onClick={shouldShowLocationSelector}
                minQty={Math.max(
                  activeLocation?.minQty,
                  activeLocation?.buyIncrement || 0
                )}
                stepSize={activeLocation?.buyIncrement}
                onInputHoverTooltipMsg={onInputTooltipMsg}
                orderNumber={orderNumber}
                isStoked={isStocked}
                value={currentQty.toString()}
                setValue={(val) => setCurrentQty(Number(val))}
                isLoading={priceSpinner}
              />
              {!inCart && (inStockSomewhere || orderIfNotAvailable) && (
                <ButtonWrapper style={{ marginTop: isCondensedView && 0 }}>
                  <AddButton
                    onClick={handleAddToCart}
                    text="addToCart"
                    disabled={isZeroCost}
                    style={{ marginTop: isCondensedView && '12px' }}
                    loading={addToCartInProgress}
                  />
                </ButtonWrapper>
              )}
              {!inStockSomewhere && !orderIfNotAvailable && (
                <ButtonWrapper style={{ marginTop: isCondensedView && 0 }}>
                  <AddButton
                    text="addToCart"
                    disabled
                    style={{ marginTop: isCondensedView && '12px' }}
                  />
                </ButtonWrapper>
              )}
              {inCart && (
                <ButtonWrapper>
                  <AddButton text={inCartText} variant="success" />
                  <DeleteWrapper onClick={handleDeletePart}>
                    <DeleteButton />
                  </DeleteWrapper>
                </ButtonWrapper>
              )}
            </MobileCartOPerations>
            <MobileProdcutLinks>
              <PartMessage message={product?.partMessage?.[0]} />
              {!hideRoutingDiagramContent && (
                <>
                  <div className="d-flex my-3 justify-content-start">
                    <MultiSellerInterchangeTooltip
                      show={showTooltip && handleTooltipDisplay()}
                    >
                      <span
                        onMouseEnter={() => {
                          setShowTooltip(true)
                        }}
                        onMouseLeave={() => setShowTooltip(false)}
                      >
                        <LocalLink
                          onClick={() => {
                            getInterchangeParts(partNumber, 'add')
                          }}
                        >
                          <I18n name="interchange" />
                        </LocalLink>
                      </span>
                    </MultiSellerInterchangeTooltip>

                    {vehicleFitment &&
                    !replacementFor &&
                    !alternateFor &&
                    showNonASTLinks ? (
                      <LocalLink
                        className="mx-3"
                        onClick={() => {
                          handleClickVehicleFitment()
                        }}
                      >
                        <I18n name="vehicleFitment" />
                      </LocalLink>
                    ) : null}
                  </div>
                  <div className="d-flex my-3 justify-content-start">
                    <LocalLink
                      onClick={() =>
                        parseAllEngines(
                          {
                            id: product?.group?.id?.toString(),
                            value: findGroupValue(
                              product?.group?.id?.toString()
                            ),
                          },
                          getCategoryId(product?.group?.id.toString())
                        )
                      }
                    >
                      <I18n name="gfxCatalog" />
                    </LocalLink>

                    {isApplicationPart() &&
                      showNonASTLinks &&
                      shouldShowLaborLink && (
                        <LocalLink onClick={handleLaborLookup} className="mx-3">
                          <I18n name="labor" />
                        </LocalLink>
                      )}
                  </div>
                </>
              )}
            </MobileProdcutLinks>
          </MobileViewProductInformation>
        </MobileViewRow>
        {openPriceInformation && (
          <ProdcutPriceDetialsDrawer
            openPriceDrawer={openPriceInformation}
            Image={productImage}
            description={description}
            productDetails={product}
            activeLocation={activeLocation}
            corePrice={coreCost}
            listPrice={list}
            YourCost={yourCostAfterPriceBreaks()}
            coreCost={1}
            otherPrices={otherPrices}
            selectedQuantity={currentQty}
            minWidth={windowSize > breakpoints.tablet ? '550px' : '0px'}
            closeDrawer={(show: boolean) => setPriceDetialsDrawer(show)}
          />
        )}
      </MobileViewCard>
    )
  }
)

interface RowProps {
  green?: boolean
  isCondensedView?: boolean
}

const Row = styled.tr<RowProps>`
  background: ${(props) =>
    props.green
      ? defaultTheme.colors.gfxBackground
      : defaultTheme.colors.componentsBackground};
  border: 24px;
  max-width: 100%;
  box-shadow: inset 0px -1px 0px ${defaultTheme.colors.border};
`
const MobileViewCard = styled(Row)`
  display: none;
  @media screen and (max-width: ${breakpoints.mobileLarge}px) {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
`

const MobileCartOPerations = styled.div``

const PriceInformation = styled.div``

const MobileWarrentyDescription = styled.div`
  text-align: start;
`

const MobileProdcutLinks = styled.div`
  display: flex;
  flex-direction: column;
  felx-wrap: wrap;
  align-items: flex-start;
  justify-content: flext-start;
`

const MinQtyDiplayer = styled.div`
  display: flex;
  flex-direction: row;
  color: #6b6b6b;
  font-size: 14px;
`

const MobileLocationAvalibailty = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
`
const MobileViewProductInformation = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  row-gap: 15px;
`
const MobileProductDetails = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`
const MobilePriceInformation = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

const MobileViewRow = styled(Row)`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  padding: 26px 18px 26px 18px;
  border-left: ${(props) =>
    props.green ? `12px solid ${defaultTheme.colors.gfxBorder}` : 'none'};
`

interface ProductNameProps {
  isLink: boolean
  isCondensedView?: boolean
}

const ProductName = styled.div<ProductNameProps>`
  font-family: Oswald, serif;
  font-size: ${(p) => (p.isCondensedView ? '16px' : '20px')};
  font-weight: bold;
  line-height: ${(p) => (p.isCondensedView ? '24px' : '30px')};
  text-decoration: ${(p) => (p.isLink ? 'underline' : 'none')};
  max-width: 250px;
  cursor: ${(p) => (p.isLink ? 'pointer' : 'initial')};
  @media screen and (max-width: ${breakpoints.mobileLarge}px) {
    text-align: left;
  }
`
interface IsCondensedViewProps {
  isCondensedView?: boolean
}

const Description = styled.div<IsCondensedViewProps>`
  font-family: Roboto, serif;
  font-size: ${(p) => (p.isCondensedView ? '14px' : '16px')};
  line-height: 24px;
  text-align: left;
  margin-top: 12px;
  max-width: 250px;
`
const MobileBrandLink = styled.div`
  margin: 20px;
`

const Wrap = styled.span<IsCondensedViewProps>`
  white-space: normal;
  font-size: ${(p) => p.isCondensedView && '14px'};
`

const NoWrap = styled.span<IsCondensedViewProps>`
  white-space: nowrap;
  font-size: ${(p) => p.isCondensedView && '14px'};
`

const PriceWrapper = styled.div<IsCondensedViewProps>`
  display: flex;
  justify-content: flex-start;
  font-size: ${(p) => p.isCondensedView && '14px'};
  width: 100%;
`

const PriceSubCell = styled.span`
  flex: 1;
  text-align: left;
  @media screen and (max-width: ${breakpoints.mobileLarge}px) {
    margin-left: 0px;
  }
`

const BigPrice = styled.span<IsCondensedViewProps>`
  font-size: ${(p) => (p.isCondensedView ? '14px' : '20px')};
  font-weight: bold;
  font-family: Roboto, serif;
`
const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 10px 0 0;
  width: 168px;
`
const DeleteWrapper = styled.div`
  padding: 0.5em;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${defaultTheme.colors.siteBackground};
  cursor: pointer;
  border-radius: 3px;
  flex-basis: 48px;
`
const AddButton = styled(Button)`
  width: 100%;
  box-sizing: border-box;
  margin-left: 0px;
  margin-right: 0px;
`
const DeleteButton = styled(Delete)`
  color: ${defaultTheme.colors.greyDark};
`
const LocalLink = styled.div`
  color: ${defaultTheme.colors.link};
  text-decoration: underline;
  cursor: pointer;
  margin: 10px 10px 0 0;
`
const LocalLinkPriceBreak = styled(LocalLink)<IsCondensedViewProps>`
  max-width: 78px;
  overflow-wrap: wrap;
  margin: ${(p) => p.isCondensedView && '0px'};
`

const ReadMore = styled.span<IsCondensedViewProps>`
  font-weight: bold;
  cursor: pointer;
  font-size: ${(p) => p.isCondensedView && '14px'};
`
const CardIconContainer = styled.div`
  background: ${defaultTheme.colors.componentsBackground};
  height: 36px;
  display: flex;
  align-items: center;
  padding: 12px 7px;
  margin-top: 12px;
  background-color: rgb(243, 242, 238);
`

const CardIcon = styled.img`
  width: 18px;
  height: 18px;
`

const MessageCardIcon = styled.p`
  font-family: Roboto, serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${defaultTheme.colors.primaryText};
  margin: 0 0 0 8px;
`

const BrandWrapper = styled.div`
  margin-top: 20px;
  cursor: pointer;
`
const BrandWrapperNoInfo = styled.div<IsCondensedViewProps>`
  margin-top: 0;
  font-size: ${(p) => p.isCondensedView && '14px'};
`

const FitsConditions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 7px;
  gap: 8px;
  min-height: 38px;
  max-width: 300px;
  background: ${defaultTheme.colors.greyVeryLight};
  border-radius: 2px;
  flex: none;
  order: 1;
  flex-grow: 0;
  margin-top: 6px;
  white-space: normal;

  .fitmentInfoIcon {
    align-self: start;
    fill: ${defaultTheme.colors.greyDark};
    width: 16px;
  }
`

const ExactMatchContainer = styled.div`
  display: flex;
  padding: 0px 4px;
  align-items: center;
  gap: 4px;
  border-radius: 4px;
  background: #ecf5e1;
  min-height: 24px;
  margin-bottom: 8px;
`

const IconCheck = styled(Check)`
  width: 18px;
  height: 18px;
`

const ExactMatchLabel = styled.span`
  color: ${defaultTheme.colors.almostBlack};
  font-variant-numeric: lining-nums tabular-nums;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
`

// const TagIcon = styled(LocalOfferIcon)`
//   color: #000;
//   font-size: 16px;
// `
